import React from 'react';
import { TRANSCRIPT_PROVIDERS } from '../../../constants/transcriptProviders';
import { TRANSCRIPTION_LANGUAGES } from '../../../constants/transcriptionLanguages';

/** The "Transcription" card: whether to transcribe right away, with which provider and spoken language. */
export default function TranscriptionCard({ form }) {
  return (
    <section className="upload-card">
      <h2>Transcription</h2>
      <label className="upload-checkbox">
        <input type="checkbox" checked={form.transcribe} onChange={(e) => form.setTranscribe(e.target.checked)} />
        <span>Start transcription after the session is created</span>
      </label>
      {form.transcribe && (
        <div className="upload-row">
          <label className="upload-field">
            <span className="upload-label">Provider</span>
            <select className="upload-input" value={form.provider} onChange={(e) => form.setProvider(e.target.value)}>
              {TRANSCRIPT_PROVIDERS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
            </select>
          </label>
          <label className="upload-field">
            <span className="upload-label">Spoken language</span>
            <select className="upload-input" value={form.language} onChange={(e) => form.setLanguage(e.target.value)}>
              {TRANSCRIPTION_LANGUAGES.map((l) => <option key={l.code} value={l.code}>{l.name}</option>)}
            </select>
          </label>
        </div>
      )}
    </section>
  );
}
